import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/shipd.svg'
import _imports_1 from '@/assets/appstoreBadge.svg'
import _imports_2 from '@/assets/googleplayBadge.svg'
import _imports_3 from '@/assets/spinner.svg'


const _withScopeId = n => (_pushScopeId("data-v-7e56ffee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "logo"
}, null, -1))
const _hoisted_3 = {
  key: 0,
  class: "download"
}
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<h1 data-v-7e56ffee> This will be the last email <br data-v-7e56ffee> to yourself, we promise :) </h1><div class=\"plattforms\" data-v-7e56ffee><a target=\"_blank\" href=\"https://apps.apple.com/se/app/shipd-mobile/id6443850361?l=en\" data-v-7e56ffee><img class=\"plattform\" src=\"" + _imports_1 + "\" alt=\"apple\" data-v-7e56ffee></a><a target=\"_blank\" href=\"https://play.google.com/store/apps/details?id=co.getshipd.mobile\" data-v-7e56ffee><img class=\"plattform\" src=\"" + _imports_2 + "\" alt=\"android\" data-v-7e56ffee></a></div>", 2)
const _hoisted_6 = {
  key: 1,
  class: "spinner",
  src: _imports_3,
  alt: ""
}
const _hoisted_7 = {
  key: 1,
  class: "download"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "This will be the last email to yourself, we promise :)", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Available for Windows 10, 11 and MacOS", -1))
const _hoisted_10 = {
  key: 1,
  class: "spinner",
  src: _imports_3,
  alt: ""
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_link, { to: "/" }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }),
    (!$setup.mobile)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _hoisted_4,
          (!$setup.isLoading)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.sendEmail && $setup.sendEmail(...args)))
              }, "Send download email"))
            : (_openBlock(), _createElementBlock("img", _hoisted_6))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _hoisted_8,
          _hoisted_9,
          (!$setup.isLoading)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.sendEmail && $setup.sendEmail(...args)))
              }, "Send download email"))
            : (_openBlock(), _createElementBlock("img", _hoisted_10))
        ])),
    _createElementVNode("button", {
      class: "skip",
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.skipWalktrough && $setup.skipWalktrough(...args)))
    }, "Skip walktrough")
  ]))
}